import React from 'react';
import { SystemStats } from '../../types';
import { Building2, FileText, History, Activity } from 'lucide-react';

interface StatsRibbonProps {
  stats: SystemStats;
}

export const StatsRibbon: React.FC<StatsRibbonProps> = ({ stats }) => {
  return (
    <div className="grid grid-cols-2 md:grid-cols-4 gap-4 mb-6">
      <div className="bg-white dark:bg-slate-800 p-4 rounded-xl border border-slate-200 dark:border-slate-700/80 shadow-2xs flex items-center gap-3.5">
        <div className="p-2.5 rounded-xl bg-indigo-50 dark:bg-indigo-950/70 text-indigo-600 dark:text-indigo-400 border border-indigo-100 dark:border-indigo-900">
          <Building2 className="w-5 h-5" />
        </div>
        <div>
          <div className="text-2xl font-bold text-slate-900 dark:text-white leading-none">
            {stats.totalCompanies}
          </div>
          <div className="text-xs text-slate-500 dark:text-slate-400 font-medium mt-0.5">
            Tracked Companies
          </div>
        </div>
      </div>

      <div className="bg-white dark:bg-slate-800 p-4 rounded-xl border border-slate-200 dark:border-slate-700/80 shadow-2xs flex items-center gap-3.5">
        <div className="p-2.5 rounded-xl bg-teal-50 dark:bg-teal-950/70 text-teal-600 dark:text-teal-400 border border-teal-100 dark:border-teal-900">
          <FileText className="w-5 h-5" />
        </div>
        <div>
          <div className="text-2xl font-bold text-slate-900 dark:text-white leading-none">
            {stats.totalPolicies}
          </div>
          <div className="text-xs text-slate-500 dark:text-slate-400 font-medium mt-0.5">
            Active Policy Feeds
          </div>
        </div>
      </div>

      <div className="bg-white dark:bg-slate-800 p-4 rounded-xl border border-slate-200 dark:border-slate-700/80 shadow-2xs flex items-center gap-3.5">
        <div className="p-2.5 rounded-xl bg-purple-50 dark:bg-purple-950/70 text-purple-600 dark:text-purple-400 border border-purple-100 dark:border-purple-900">
          <History className="w-5 h-5" />
        </div>
        <div>
          <div className="text-2xl font-bold text-slate-900 dark:text-white leading-none">
            {stats.totalRevisions}
          </div>
          <div className="text-xs text-slate-500 dark:text-slate-400 font-medium mt-0.5">
            Historical Snapshots
          </div>
        </div>
      </div>

      <div className="bg-white dark:bg-slate-800 p-4 rounded-xl border border-slate-200 dark:border-slate-700/80 shadow-2xs flex items-center gap-3.5">
        <div className="p-2.5 rounded-xl bg-emerald-50 dark:bg-emerald-950/70 text-emerald-600 dark:text-emerald-400 border border-emerald-100 dark:border-emerald-900">
          <Activity className="w-5 h-5" />
        </div>
        <div>
          <div className="text-2xl font-bold text-emerald-600 dark:text-emerald-400 leading-none">
            Live
          </div>
          <div className="text-xs text-slate-500 dark:text-slate-400 font-medium mt-0.5">
            Ingestion Engine
          </div>
        </div>
      </div>
    </div>
  );
};
